import { apiFetch } from './client';

/**
 * ALTA DE NEGOCIOS (tenants).
 * Prefijo: /api/tenants
 *
 * Esteban lo pidió en mayúsculas: *"COMO SEA MAS FACIL PARA MONTAR MAS NUMEROS
 * ALLI EN TENANT DIFERENTES"*. Mute Monkey, RESIST y Dreo son negocios
 * distintos, con su WhatsApp, su Inspector y sus objetivos.
 *
 * Hasta hoy el alta existía como servicio y como ruta, pero no había pantalla:
 * montar un negocio pedía una consola. Esto lo cierra.
 */

export type TipoDeNegocio = 'personal' | 'atencion' | 'relay' | 'campanas' | 'difusion_grupos';

export interface AltaDeTenant {
  nombre: string;
  slug: string;
  /** Con qué módulos nace. Por defecto `personal`: el del Inspector. */
  tipo?: TipoDeNegocio;
  timezone?: string;
  currencyPrefix?: string;
  responsable: {
    email: string;
    nombre?: string;
    /** Sólo si el usuario todavía no existe. */
    password?: string;
    rol?: 'OWNER' | 'ADMIN' | 'AGENT' | 'VIEWER';
  };
  canal?: { nombre: string };
  inspector?: { objetivos?: string[]; queIgnorar?: string };
}

export interface TenantCreado {
  workspaceId: string;
  slug: string;
  nombre: string;
  userId: string;
  /** `false` = el responsable ya existía y se le dio membresía, no se creó. */
  usuarioNuevo: boolean;
  channelId: string | null;
  /**
   * Lo que el alta NO pudo dejar listo. Viaja a propósito: un alta que dice
   * "listo" cuando faltan cosas es peor que una que las enumera.
   */
  loQueFalta: string[];
}

export function crearTenant(input: AltaDeTenant): Promise<TenantCreado> {
  return apiFetch('/api/tenants', { method: 'POST', body: input });
}
